/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Ex_OhpInputs */

const en_features_ex_ohp = /** @type {(inputs: Features_Ex_OhpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overhead press`)
};

const pl_features_ex_ohp = /** @type {(inputs: Features_Ex_OhpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyciskanie nad głowę`)
};

/**
* | output |
* | --- |
* | "Overhead press" |
*
* @param {Features_Ex_OhpInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_ex_ohp = /** @type {((inputs?: Features_Ex_OhpInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Ex_OhpInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_ex_ohp(inputs)
	return en_features_ex_ohp(inputs)
});